import React from "react";
// Material Imports
import { makeStyles } from "@material-ui/core/styles";
import { hexToRgb } from "@material-ui/core/styles/colorManipulator"; //Limitless imports

import UserAvatar from "../../user-avatar/UserAvatar";
import FadeUp from "../../animation/fade-up/FadeUp";
var useStyles = makeStyles(function (_ref) {
  var _palette$dialogues$ex, _palette$dialogues, _palette$dialogues$ex2, _palette$dialogues$ex3, _palette$dialogues2, _palette$dialogues2$e, _palette$dialogues$ex4, _palette$dialogues3, _palette$dialogues3$e;

  var palette = _ref.palette;
  var background = (_palette$dialogues$ex = (_palette$dialogues = palette.dialogues) === null || _palette$dialogues === void 0 ? void 0 : (_palette$dialogues$ex2 = _palette$dialogues.expert) === null || _palette$dialogues$ex2 === void 0 ? void 0 : _palette$dialogues$ex2.background) !== null && _palette$dialogues$ex !== void 0 ? _palette$dialogues$ex : palette.primary.light;
  var text = (_palette$dialogues$ex3 = (_palette$dialogues2 = palette.dialogues) === null || _palette$dialogues2 === void 0 ? void 0 : (_palette$dialogues2$e = _palette$dialogues2.expert) === null || _palette$dialogues2$e === void 0 ? void 0 : _palette$dialogues2$e.text) !== null && _palette$dialogues$ex3 !== void 0 ? _palette$dialogues$ex3 : palette.primary.dark;
  var borderRadius = (_palette$dialogues$ex4 = (_palette$dialogues3 = palette.dialogues) === null || _palette$dialogues3 === void 0 ? void 0 : (_palette$dialogues3$e = _palette$dialogues3.expert) === null || _palette$dialogues3$e === void 0 ? void 0 : _palette$dialogues3$e.borderRadius) !== null && _palette$dialogues$ex4 !== void 0 ? _palette$dialogues$ex4 : 12;
  return {
    //expert classes
    expertText: {
      color: text
    },
    expertBackground: {
      backgroundColor: background
    },
    expertTyping: {
      backgroundColor: text
    },
    blurText: {
      color: "transparent",
      textShadow: "0 0 10px ".concat(hexToRgb(palette.secondary.dark)),
      userSelect: "none"
    },
    listItem: {
      display: "flex",
      marginLeft: 5,
      position: "relative",
      borderRadius: borderRadius,
      padding: 16,
      flexDirection: "column"
    },
    responseTime: {
      display: "flex",
      flex: "1",
      justifyContent: "flex-start",
      paddingTop: 5,
      paddingLeft: 5
    },
    //classes for this comp
    avatar: {
      boxShadow: "0px 0px 5px 2px rgba(97, 97, 97, 1)"
    },
    avatarContainer: {
      paddingLeft: 5
    },
    responseContainer: {
      paddingTop: 10,
      paddingBottom: 10
    },
    responseListContainer: {
      display: "flex",
      flex: "1",
      flexDirection: "row",
      maxWidth: "90%"
    }
  };
});

var ExpertDialogueWrapper = function ExpertDialogueWrapper(_ref2) {
  var shouldAnimate = _ref2.shouldAnimate,
      children = _ref2.children,
      expertInfo = _ref2.expertInfo,
      author = _ref2.author,
      _ref2$dialogueContain = _ref2.dialogueContainerOverrides,
      dialogueContainerOverrides = _ref2$dialogueContain === void 0 ? "" : _ref2$dialogueContain;
  var classes = useStyles();
  var thumbnail = expertInfo ? expertInfo.thumbnail : null;
  var hideExpertAvatar = !expertInfo ? true : false;
  return /*#__PURE__*/React.createElement(FadeUp, {
    shouldAnimate: shouldAnimate
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.responseContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.responseListContainer, " ").concat(dialogueContainerOverrides)
  }, !hideExpertAvatar && /*#__PURE__*/React.createElement("div", {
    className: classes.avatarContainer
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    author: author,
    thumbnail: thumbnail
  })), children(classes))));
};

export default ExpertDialogueWrapper;
ExpertDialogueWrapper.defaultProps = {
  hideExpertAvatar: false
};